// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { motion, useAnimation } from 'framer-motion';
import { Box, Image, Divider, Button, Grid, Text, Flex, useBreakpointValue, useColorModeValue } from '@chakra-ui/react';
import { NavLink, Link, useHistory, useLocation } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import { ReactComponent as PlusCategoryIcon } from 'assets/svg/show-category-parent.svg';

// Components
import { ArrowCategoryIcon } from 'components/Icons/Icons';
import Partners from '../../Partners';

const Stores = ({userData}) => {
    const textColor = useColorModeValue('#0E1633', 'white');
    const borderBottom = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');

    const [collapsedItems, setCollapsedItems] = useState(false); 
    const toggleItems = () => {
        setCollapsedItems(!collapsedItems);
    };

    const responsiveSettings = useBreakpointValue({ base: true, md: false });
    useEffect(() => { setCollapsedItems(responsiveSettings); }, [responsiveSettings]);

    return (
        <>
            <Flex alignItems="center" justifyContent="space-between" pt="10px">
                <Text variant="text-md" color={textColor} fontWeight="500">
                    Stores
                </Text>
                <ArrowCategoryIcon 
                    fontSize="24px"
                    transition="0.2s all"
                    transform={ collapsedItems ? 'rotate(90deg)' : 'rotate(0deg)' } 
                    onClick={toggleItems} />
            </Flex>
        
            <Box 
                maxH={ collapsedItems ? '0px' : '100%' } 
                transition="0.2s all" 
                overflowY={ collapsedItems ? 'hidden' : 'scroll'}
                opacity={ collapsedItems ? '0' : '1'}
                sx={{
                    '&::-webkit-scrollbar': { display: 'none' }, 
                    '-ms-overflow-style': 'none', 
                    'scrollbar-width': 'none',
                }} 
                p="24px 12px 0 12px">
                <Partners 
                    key="stores" 
                    userData={userData}
                    type="partner" 
                    limit={6}
                    tops="shop"
                    isStores={true}
                    isGrid={false}
                    includeLoadMore={false}/>
            </Box>

            <Box borderTop={borderBottom} opacity={collapsedItems ? '0' : '1'} />
        </>
    );
};


export default Stores;